import React, { useEffect, useState } from "react";
import { SelectAsyncOptionType } from "react-select/async";
import { SmSelectAsyncSearchBox } from "../../../controls/components/selectAsyncSearchBox/SelectAsyncSearchBox";
import { ListPartnerSearch, ListUserSearch } from "../../../../services/UserService";
import { getListPartnerEmail, ListDescriptionSearch } from "../../../../services/PartnerService";

export function AdminFilterEmailPartner(props: { filterStaffId?: string; doChangeStaffId?: (value: any) => void, name?: boolean, all?: boolean }) {
	const [selectedId, setSelectedId] = useState<string>(props.filterStaffId || "");
	useEffect(() => {
		setSelectedId(props.filterStaffId || "");
	}, [props.filterStaffId]);
	const loadStaffList = async (input: string, setOpts: (val: SelectAsyncOptionType[]) => void) => {
		try {
			const data = await getListPartnerEmail(input, props.name);
			const res = data;
			if (res) {
				const selectOpts = convertToSelectOptions(res, props.name, props.all);
				const filteredOptions = selectOpts.filter((option: any) =>
					option.label.toLowerCase().includes(input.toLowerCase())
				);
				const clearOption = { label: "All", value: "" };
				setOpts?.([clearOption, ...filteredOptions]);
				return [clearOption, ...filteredOptions];
			}
		} catch (err) {
			console.error(err);
		}

		setOpts([]);
		return;
	};

	return (
		<SmSelectAsyncSearchBox
			selectedId={selectedId}
			onChange={(value: any) => {
				setSelectedId(value);
				props.doChangeStaffId?.(value);
			}}
			loadOptionPromise={loadStaffList}
		/>
	);
}

export function convertToSelectOptions(data: any, name?: boolean, all?: boolean) {
	let selectOptions = data.map((item: any) => ({
		value: name ? item.fullName : item.id,
		label: all ? `${item.email} (${item.fullName})` : (name ? item.fullName : item.email),
		object: "",
	}));
	return selectOptions;
}
